import { render, staticRenderFns } from "./EmailTicket.vue?vue&type=template&id=451316b6&"
import script from "./EmailTicket.vue?vue&type=script&lang=js&"
export * from "./EmailTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports